"use client";
import React from 'react';
import { SelectedLocationContext } from '../providers/SelectedLocationProvider.js';

function useSelectedLocation() {
    const selectedLocation = React.useContext(SelectedLocationContext);
    return selectedLocation;
}

export { useSelectedLocation };
//# sourceMappingURL=useSelectedLocation.js.map
